<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
       <b-breadcrumb :items="breadcrumbs"/> 
        <b-card>         
         
            <b-row>           
                
                <b-col md="4">  
                  <b-form-group label="Client"  :label-cols="3" >
                      <!-- <b-form-select v-model="deliveryagentmasterid" name="deliveryagentmasterid" class="mySelectBox" v-validate="'required|'">
                          <option :value="selected">--Select Delivery Agent--</option>
                          <option :value="customer.deliveryagentmasterid" v-for="customer in data1">{{ customer.deliveryagentfirstname | capitalize }} {{ customer.deliveryagentlastname | capitalize }}-{{ customer.deliveryagentmasterid }}</option>s
                      </b-form-select> -->
                      <v-select  v-model="deliveryagentmasterid" :options="data1" placeholder="Select Delivery Agent" @input="selectdeliveryagent(deliveryagentmasterid)" >
                      </v-select>
                  </b-form-group>
                </b-col>  

             
               <!--  <b-col md="4">  
                  <b-form-group>
                      <v-date-picker mode='single' :available-dates='{ start: null, end: new Date() }' v-model='selectedValue'>
                      </v-date-picker>
                  </b-form-group>
                </b-col>  --> 
               
                 <b-col md="12">  
                 
                  <b-button  id='forwardpickup' class="forwrd" value="forwardpickup"  size="md" variant="primary"  v-on:click="searchAgent($event)">Forward Pickup
                </b-button>&nbsp;&nbsp;&nbsp;
                
                  <b-button  id='reversepickup'  class="forwrd" value="reversepickup"   size="md" variant="primary"  v-on:click="searchAgent($event)" >Reverse Pickup
                </b-button>&nbsp;&nbsp;&nbsp;

                 <b-button  id='ofd' value="ofd"  class="forwrd" size="md" variant="primary"  v-on:click="searchAgent($event)" >OFD
                </b-button>&nbsp;&nbsp;&nbsp;
                </b-col> 

               <!--  <b-col md="4">  
                  <b-button  type="submit" size="md" variant="primary" v-on:click="searchAgent">Search
                </b-button>
                </b-col>  -->
                
                <div style="clear:both"></div>
                <div id="displayErrorMessage" style="margin:5px; display:none;">
                    <span v-show="errors.has('form-1.deliveryagentmasterid')" class="help is-danger">{{ errors.first('form-1.deliveryagentmasterid') }}</span>
                    <span style="color:red">Record Not Found</span>
                </div>

            </b-row>    
        

           <b-col cols="12" md="12" class="mt-4">
          <div id="dvMap" style="width:100%;height:400px;" :busy="isBusy">
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
          </div>
          </b-col>
        </b-card>
      </b-col>
    </b-row>        
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants"
import Utils from "@/utils"
export default {
  data: function  () {
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    return {
       isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Track Shipment',
        active: true
      }],
      selected:'',
      selectedValue: new Date(),
      buttonValue:'',
      name: 'deliveryagentmaster',
      deliveryagentmasterid: '',
      data1: [],
      date: '20180225',
      customer: { isverified: true },
      markersTemp: [],
      markers: [
        {
          title: 'A',
          lat: '25.27537',
          lng: '55.30404',
          description: 'A'
        }
      ]
    };
  },
  components: {},
  created: function() {
    (function()
{
  if( window.localStorage )
  {
    if( !localStorage.getItem('firstLoad') )
    {
      localStorage['firstLoad'] = true;
      window.location.reload();
    }
    else
      localStorage.removeItem('firstLoad');
  }
})();
    this.displaydata()
    //this.setDate()
    this.getData()
  },
  methods: {
    // validateForm: function(scope) {
    //   this.$validator.validateAll(scope).then(result => {
    //   });
    // },
    // setDate: function() {
    //   var d = new Date(this.selectedValue),
    //     month = "" + (d.getMonth() + 1),
    //     day = "" + d.getDate(),
    //     year = d.getFullYear()
    //   if (month.length < 2) month = '0' + month
    //   if (day.length < 2) day = '0' + day;
    //   this.date = [year, month, day].join('-');
    // },

    selectdeliveryagent(value_vehicle) {
        if(value_vehicle==null){
          this.deliveryagentmasterid = '';
          this.displaydata();
          this.getData();
        }
         console.log("value_vehicle : ",value_vehicle);
      },

     GetSortOrder: function(prop) {
     return function(a, b) {
         if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
           return -1;
        }
        return 0;
      };
     },
    displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      const deliveryagentobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagentobj)
        .then(result => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
          // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
    },
   

    searchAgent: function(e) {
      
     // console.log(e);
    //  $("#forwardpickup").css("background-color","#20a8d8");
    //  document.getElementsByClass("forwardpickup").style.backgroundColor="#20a8d8";
    //  document.getElementsByClassName("btn").style.backgroundColor="red";
    // e.target.style.backgroundColor = "#f09642";

    var buttonValue = e.target.value;
     
    localStorage.setItem("buttonValue", buttonValue);
     // this.setDate()
      this.getData()
    },




    getData: function() {

       this.isBusy = true;
 
      var requestObj = {
        deliveryagentmasterid: this.deliveryagentmasterid.key,
        shipmentstatus:localStorage.getItem("buttonValue"),
      };

    
      
      var myPromiss = [];
      myPromiss[0] = this.$http.post(
        `${CONSTANTS.API_URL}/ConsignmentMaster/GetAllShipmentsListByStatus`,
        requestObj
      );
      // myPromiss[1] = this.$http.post(
      //   `${CONSTANTS.API_URL}/ConsignmentMaster/GetAllShipmentsListByStatus`,
      //   requestObj
      // );

//console.log( myPromiss[0]);
      Promise.all(myPromiss)
        .then(responseData => {
          this.isBusy = !this.isBusy

          if (responseData[0].data.message === 'success') {

            this.markersTemp = responseData[0].data.data.shipment_list;
     // this.markersTemp1 = responseData[0].data.data.shipment_list[0].pickuplocation;
            this.markersTemp.sort(this.GetSortOrder('201802252055'));
            var checkFlag = 1;
          } else {
            checkFlag = 0
          }
          // if (responseData.data.message === 'success') {

          //   this.markers = responseData[1].data.returnvalue;
          //   this.markers.sort(this.GetSortOrder('201802252055'))
          //   var checkFlag = 1;
          // } else {
          //   checkFlag = 0
          // }

          if (checkFlag) {
            this.showMap()
          } else {
            
            this.showBlankMap()
          }
        })
        .catch(error => {
         
          this.showBlankMap()
          console.log('got error',error)
        });
    },
    showBlankMap:function(){
       
      var mapOptions = {
        center: new google.maps.LatLng('25.27537','55.30404'),
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(
        document.getElementById("dvMap"),
        mapOptions
      )
    },
//     showMap: function(flag) {
     

// var picklatlong_x=this.markersTemp[0].picklatlong_x;
// var picklatlong_y=this.markersTemp[0].picklatlong_y;

//       var mapOptions = {
//         center: new google.maps.LatLng(
//          picklatlong_x,
//           picklatlong_y
//         ),
//         zoom: 10,
//         mapTypeId: google.maps.MapTypeId.ROADMAP
//       };

//       console.log("FFFFFFFFFFFFF",mapOptions);
//       var path = new google.maps.MVCArray();
//       var bounds = new window.google.maps.LatLngBounds();
//       var directionsService = new google.maps.DirectionsService();

//       let directionsDisplay = new google.maps.DirectionsRenderer(
//         {
//           suppressMarkers: false
//         });


//       directionsDisplay.setMap(null);
//       var infoWindow = new google.maps.InfoWindow()
//       var map = new google.maps.Map(
//         document.getElementById("dvMap"),
//         mapOptions
//       )
//         let greenMarker = {
//        url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
//        size: new window.google.maps.Size(25, 35),
//        origin: new window.google.maps.Point(6, 0)
//      };
//      let redMarker = {
//     url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
//     size: new window.google.maps.Size(25, 35),
//     origin: new window.google.maps.Point(6, 0)
//   };
//      //let routesArr = [];
//      let wayptsArr=[];

//      //console.log("lennnnn",this.markersTemp.length);
//      for (var i = 0; i < this.markersTemp.length; i++) {

//        wayptsArr.push({lat: this.markersTemp[i].picklatlong_x,lng:this.markersTemp[i].picklatlong_y});
     
//      }
//      // for (var i = 0; i < this.markersTemp.length; i++) {
//      //   routesArr.push({lat: this.markersTemp[i].picklatlong_x,lng:this.markersTemp[i].picklatlong_y});
//      // }
//      let startPoint= {lat:this.markersTemp[0].picklatlong_x,lng:this.markersTemp[0].picklatlong_y};
//      //let endPoint= {lat:this.markers[1].picklatlong_x,lng:this.markers[1].picklatlong_y};
//      let waypts = [];
//        wayptsArr.map(location =>{
//          // let marker = new google.maps.Marker({
//          //   position: new google.maps.LatLng(location.lat,
//          //     location.lng),
//          //   map,
//          //   icon: greenMarker
//          // });
//          waypts.push({
//            location: new window.google.maps.LatLng(location.lat,
//              location.lng), stopover: true
//          });
//        });
//        let firstShipment = waypts.shift();
//       //let lastShipment = waypts.pop();
//        directionsService.route({
//          origin:(firstShipment.location),
//         destination:(firstShipment.location),
//          waypoints: waypts,
//          optimizeWaypoints: true,
//          provideRouteAlternatives:true,
//          travelMode: window.google.maps.TravelMode.DRIVING
//        }, (response, status) => {
//         console.log(status);
//          if (status === window.google.maps.DirectionsStatus.OK) {
//            for (let i = 0, len = response.routes.length; i < len; i++) {
//              new window.google.maps.DirectionsRenderer({
//                suppressMarkers: true,
//                map,
               
//                routeIndex: i,
               
//              });
//              directionsDisplay.setDirections(response);
//              directionsDisplay.setMap(map);
             
//            }
//          } else {
//            window.alert('Directions request failed due to ' + status);
//          }
//        });
//        google.maps.event.addListenerOnce(map, 'idle', function() {
//          google.maps.event.trigger(map, 'resize');
//        });
//     //  FAPosition=Field Agent Start and End Location
//       // let FAStartPoint = new google.maps.Marker({
//       //    position:new google.maps.LatLng(startPoint),
//       //    map: map,
//       //    icon: greenMarker
//       //  });
//       //  let FAEndPoint = new google.maps.Marker({
//       //     position:new google.maps.LatLng(endPoint),
//       //     map: map,
//       //     icon: greenMarker
//       //   });
//       // let lineSymbol = {
//       //    path: google.maps.SymbolPath.CIRCLE,
//       //    scale: 3,
//       //    strokeColor: '#393'
//       //  };

//       // var line = new google.maps.Polyline({
//       //   path: routesArr,
//       //   strokeOpacity: 1,
//       //   strokeWeight: 0,
//       //   icons: [{
//       //     icon: lineSymbol,
//       //     offset: '100%',
//       //     repeat: '10px'
//       //   }],
//       //   map: map
//       // });
//       // bounds.extend(FAStartPoint.getPosition());
//       // bounds.extend(FAEndPoint.getPosition());
//       // map.panToBounds(bounds);
//       // window.location.reload();
//     }
//   },
   showMap: function(flag) {
     

var picklatlong_x=this.markersTemp[0].picklatlong_x;
var picklatlong_y=this.markersTemp[0].picklatlong_y;

      var mapOptions = {
        center: new google.maps.LatLng(
         picklatlong_x,
          picklatlong_y
        ),
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      // console.log("FFFFFFFFFFFFF",mapOptions);
      var path = new google.maps.MVCArray();
      var bounds = new window.google.maps.LatLngBounds();
      var directionsService = new google.maps.DirectionsService();
      let directionsDisplay = new google.maps.DirectionsRenderer(
        {
          suppressMarkers: false
        });
        directionsDisplay.setOptions({
  polylineOptions: {
    strokeColor: 'white',
   
  }
});

      var infoWindow = new google.maps.InfoWindow()
      var map = new google.maps.Map(
        document.getElementById("dvMap"),
        mapOptions
      )
        
    
     //let routesArr = [];
     let wayptsArr=[];

     //console.log("lennnnn",this.markersTemp.length);
     for (var i = 0; i < this.markersTemp.length; i++) {

       wayptsArr.push({lat: this.markersTemp[i].picklatlong_x,lng:this.markersTemp[i].picklatlong_y});
     
     }
     // for (var i = 0; i < this.markersTemp.length; i++) {
     //   routesArr.push({lat: this.markersTemp[i].picklatlong_x,lng:this.markersTemp[i].picklatlong_y});
     // }
     let startPoint= {lat:this.markersTemp[0].picklatlong_x,lng:this.markersTemp[0].picklatlong_y};
     //let endPoint= {lat:this.markers[1].picklatlong_x,lng:this.markers[1].picklatlong_y};
     let waypts = [];
       wayptsArr.map(location =>{
        
         waypts.push({
           location: new window.google.maps.LatLng(location.lat,
             location.lng), stopover: true
         });
       });
       let firstShipment = waypts.shift();
      //let lastShipment = waypts.pop();
       directionsService.route({
         origin:(firstShipment.location),
        destination:(firstShipment.location),
         waypoints: waypts,
         optimizeWaypoints: true,
         provideRouteAlternatives:true,
         travelMode: window.google.maps.TravelMode.DRIVING
       }, (response, status) => {
        // console.log(status);
         if (status === window.google.maps.DirectionsStatus.OK) {
           for (let i = 0, len = response.routes.length; i < len; i++) {
             new window.google.maps.DirectionsRenderer({
               suppressMarkers: true,
               map,
               directions: response,
               routeIndex: i,
               polylineOptions: {
                 strokeColor: "white"
               }
             });
             directionsDisplay.setDirections(response);
             directionsDisplay.setMap(map);
           
           }
         } else {
           window.alert('Directions request failed due to ' + status);
         }
       });
       google.maps.event.addListenerOnce(map, 'idle', function() {
         google.maps.event.trigger(map, 'resize');
       });
   
    }
  },

  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>
<style type="text/css">
  

.forwrd:focus,
.forwrd:active,
.forwrd.active {
    background-color: #f09642!important;
     outline: none !important;
  box-shadow: none !important;
  border-color: #f09642!important
}

</style>



